import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import handSrc from '@cover/weitertesten/hand.png';
import virusSrc from '@cover/weitertesten/virus.png';

const AnimatedLayer = styled.img`
	position: absolute;
	z-index: 999;
`

const Hand = styled(AnimatedLayer)`
	height: 52%;
	left: -70%;
	bottom: -15%;
	transform-origin: bottom left;
`
const VirusTop = styled(AnimatedLayer)`
	height: 18%;
	top: 3.5%;
	right: -1%;
`
const VirusCenter = styled(AnimatedLayer)`
	height: 26.5%;
	top: 22%;
	left: 0%;
`
const VirusBottom = styled(AnimatedLayer)`
	height: 41%;
	bottom: -2.5%;
	right: 1%;
`


const WeiterTesten = ({ play }) => {
	const hand = useRef(false);
	const virusTop = useRef(false);
	const virusCenter = useRef(false);
	const virusBottom = useRef(false);

	useEffect(() => {
		anime({
			targets: hand.current,
			autoplay: play,
			duration: 4000,
			loop: true,
			keyframes:[
				{translateY: '-25%', translateX: '84%', rotate: 1, duration: 2600, easing: 'easeInOutSine'},
				{translateY: '-29%', translateX: '90%', rotate: 3, duration: 800, easing: 'easeInOutSine'},
				{translateY: '-16%', translateX: '84%', rotate: 2, duration: 800, easing: 'easeInOutSine'},
				{translateY: '-21%', translateX: '75%', rotate: 1, duration: 800, easing: 'easeInOutSine'},
				{translateY: '0%', translateX: '0%', rotate: -8, duration: 2600, easing: 'easeInOutSine', endDelay: 2000}
			]
		});
		anime({
			targets: virusTop.current,
			autoplay: play,
			duration: 5500,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '0%', translateX: '-2%'},
				{translateY: '3%', translateX: '-1.5%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: virusCenter.current,
			autoplay: play,
			duration: 5100,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-1%', translateX: '2.5%'},
				{translateY: '-1.5%', translateX: '1.5%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
		anime({
			targets: virusBottom.current,
			autoplay: play,
			duration: 5300,
			loop: true,
			direction: 'alternate',
			easing: 'easeInOutSine',
			keyframes: [
				{translateY: '-1%', translateX: '-2%'},
				{translateY: '-2%', translateX: '1%'},
				{translateY: '0%', translateX: '0%'}
			]
		});
	}, [play])
	return (
		<>
			<Hand src={handSrc} ref={hand} />
			<VirusTop src={virusSrc} ref={virusTop} />
			<VirusCenter src={virusSrc} ref={virusCenter} />
			<VirusBottom src={virusSrc} ref={virusBottom} />
		</>
	)
};

export default WeiterTesten;